/**
 * Endpoint configuration for chain mode (the local chain, a testnet or Robinhood Chain). Build-time env (Vite):
 *   VITE_CHAIN_ID           the chain this site is built for (default 31337, the local Anvil chain; 4663 = Robinhood
 *                           Chain mainnet). The deployment manifest and the RPC must report the same chain.
 *   VITE_DEFAULT_MODE       'demo' or 'local' (chain mode) on a first visit; default: demo on 31337, chain mode elsewhere
 *   VITE_RUNNER_API         read API base URL (default http://127.0.0.1:8787; VITE_API_URL is accepted as an alias)
 *   VITE_RPC_URL            chain RPC used for wallet transactions and wallet balances (default http://127.0.0.1:8545)
 *   VITE_RUNNER_DEPLOYMENT  fallback deployment manifest URL when the API's /v1/deployment is unreachable
 *                           (default /local-deployment.json)
 * The API never holds keys: transactions are signed in the browser wallet and sent straight to the chain.
 */
const env = import.meta.env as Record<string, string | undefined>;

function trimSlash(u: string): string {
  return u.replace(/\/+$/, '');
}

export const RUNNER_API = trimSlash(env.VITE_RUNNER_API || env.VITE_API_URL || 'http://127.0.0.1:8787');
export const RPC_URL = env.VITE_RPC_URL || 'http://127.0.0.1:8545';
export const DEPLOYMENT_URL = env.VITE_RUNNER_DEPLOYMENT || '/local-deployment.json';
export const CHAIN_ID = Number(env.VITE_CHAIN_ID || 31337);
/** Experimental pre-authorized play is opt-in for a separately wired deployment. Never enabled implicitly. */
export const PLAY_SESSIONS_ENABLED = env.VITE_ENABLE_PLAY_SESSIONS === '1';
/** The simulated demo exists only in local builds (chain 31337, where the e2e tests use it) or when explicitly asked
 *  for with VITE_ENABLE_DEMO=1. A Robinhood Chain build keeps account/economy data live with no mode switch. Free practice uses a separate local track. */
export const DEMO_ENABLED = CHAIN_ID === 31337 || env.VITE_ENABLE_DEMO === '1';
export const DEFAULT_MODE: 'demo' | 'local' = !DEMO_ENABLED
  ? 'local'
  : env.VITE_DEFAULT_MODE === 'demo' || env.VITE_DEFAULT_MODE === 'local'
    ? env.VITE_DEFAULT_MODE
    : CHAIN_ID === 31337
      ? 'demo'
      : 'local';
